export * from '../../../components/FooterV2/FooterItem/FooterItem';
